export default __webpack_public_path__ + "static/media/14.df599aa1.png";